import React, { Component } from 'react';
import { getXsellUrl } from 'utils/commonUtils';

const appUserAgentRegex = /SkySportingLife\/([0-9a-zA-Z.]+)/;

const products = [
    { appName: "skybet", imageName: "skybet-dec2017", href: "https://m.skybet.com", affId: "10392", dcmp: "SL_LOGO_SB_19" },
    { appName: "skyvegas", imageName: "sky-vegas-feb2018", href: "https://www.skyvegas.com/", affId: "1197321629", dcmp: "SL_LOGO_SV_19" },
    { appName: "skysports", imageName: "skysports-aug2017", href: "http://www.skysports.com/", affId: "1197321630", dcmp: "SL_LOGO_SSDM_19" },
    { appName: "skyc4racingpick6", imageName: "itv7-feb2018", largeImage: true, href: "https://itv7.itv.com/", affId: "1197321631", dcmp: "SL_LOGO_FTP_ITV7_19" },
    { appName: "super6", imageName: "super6-dec2017", largeImage: true, href: "https://super6.skysports.com/", affId: "1197321632", dcmp: "SL_LOGO_FTP_S6_19" },
    { appName: "skycasino", imageName: "sky-casino-feb2018", href: "https://www.skycasino.com/", affId: "1197321633", dcmp: "SL_LOGO_SC_19" },
    { appName: "SkyFF", imageName: "fantasy-football-dec2017", largeImage: true, href: "https://fantasyfootball.skysports.com/", affId: "1197321634", dcmp: "SL_LOGO_FTP_FF_19" },
    { appName: "skypoker", imageName: "sky-poker-feb2018", href: "https://www.skypoker.com/", affId: "1197321636", dcmp: "SL_LOGO_FTP_SP_19" },
    { appName: "skybingo", imageName: "sky-bingo-feb2018", href: "https://www.skybingo.com/", affId: "1197321637", dcmp: "SL_LOGO_SBIN_19" }
];

export default class Masthead extends Component {
    bindAppLinks() {
        if (!window.SkyBetAccount) {
            return false;
        }

        // Don't enable appbridge if not being accessed through app
        if (!this.getAppVersion()) {
            return true;
        }

        const appLinks = document.getElementsByClassName('js-app-link');

        let self = this;
        [].forEach.call(appLinks, link => {
            link.addEventListener('click', evt => {
                self.openAppLink(link, evt);
            })
        })

        return true;
    }

    getAppVersion() {
        const userAgent = window.navigator.userAgent;
        const appVersion = userAgent.match(appUserAgentRegex);

        if (!appVersion) {
            return false;
        }
        return appVersion[1];
    }

    openAppLink(link, evt) {
        const appName = link.getAttribute('data-app-name');
        const appLink = link.getAttribute('data-app-link');
        let sba = window.SkyBetAccount;
        let appBridge = sba.getAppBridge();

        if (!(appName && appLink)) {
            return;
        }
        evt.preventDefault();

        // The iOS app will prepend the scheme
        let transferUrl = appLink.replace(/^https?:\/\//, '');

        // Only get a transfer token if we are on https and logged in
        if (window.location.protocol === 'https:' && sba.getLastLoginState() === 'loggedIn') {
            sba.getSsoTransferToken(function(err, ssoTransferToken) {
                if (!err) {
                    // Append the SSO transfer token to the URL
                    transferUrl += (transferUrl.indexOf('?') !== -1) ? '&' : '?';
                    transferUrl += 'sba_transferToken=' + ssoTransferToken;
                } else {
                    console.log('Unable to transfer SSO session');
                }

                appBridge.trigger('openAppLink', {
                    app: appName,
                    url: transferUrl
                });
            });
        }
        else {
            appBridge.trigger('openAppLink', {
                app: appName,
                url: transferUrl
            });
        }
    }

    productListItem(item) {
        const targetUrl = getXsellUrl(`${item.href}?AFF_ID=${item.affId}&dcmp=${item.dcmp}`, item.ssoConsumer);

        return(
            <li className="masthead-item" key={products.indexOf(item)}>
                <a className="js-app-link" data-app-name={item.appName} data-app-link={targetUrl} href={targetUrl} target="_blank" rel="external">
                    <img className={item.largeImage ? 'masthead-large' : ''} src={`/img/masthead/${item.imageName}.png`} />
                </a>
            </li>
        );
    }

    componentDidMount() {
        this.retriesLeft = 100; // arbitrary 10 second wait for the API to appear
        this.interval = setInterval(() => {
          if (this.bindAppLinks() || --this.retriesLeft === 0) {
            clearInterval(this.interval);
            this.interval = null;

            if (!this.retriesLeft) {
                /* eslint-disable no-console */
              console.warn('Could not find SkyBetAccount integration object');
                /* eslint-enable no-console */
            }
          }
        }, 100);
    }

    render() {
        return (
            <nav className="masthead">
                <ul className="masthead-items">
                    {products.map(product => this.productListItem(product))}
                </ul>
            </nav>
        );
    }
}



// WEBPACK FOOTER //
// ./modules/Common/components/Masthead.js